require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./coding-interview-prep-take-home-projects-build-a-pong-game.json") })
        }
      }, "path---coding-interview-prep-take-home-projects-build-a-pong-game");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---coding-interview-prep-take-home-projects-build-a-pong-game!./.cache/json/coding-interview-prep-take-home-projects-build-a-pong-game.json
// module id = 1921
// module chunks = 231608221292675